import { DirectUpload } from '@rails/activestorage';

// Wrap activestorage direct upload in a promise so we can use it
// with async / await
export const directUpload = async file => {
  const promise = await new Promise((resolve, reject) => {
    const url = '/rails/active_storage/direct_uploads';
    const uploader = new DirectUpload(file, url);

    uploader.create((error, blob) => {
      if (error) {
        reject(error);
      } else {
        resolve(blob);
      }
    });
  }).catch(err => {
    throw err;
  });

  return promise;
};
